export const ATTESTATION_SCREEN_HEADER =
  "Before proceeding further we need you to confirm the following";

export const ATTESTATION_SCREEN_QUESTION_1_ENTITY_TYPE_L = `Having considered fully the Pay as you Grow (PAYG) options and my directors’ duties and my business’ 
  financial position, I have concluded that my business is in financial difficulty and I would like to discuss with you my circumstances`;
export const ATTESTATION_SCREEN_QUESTION_1_ENTITY_TYPE_NOT_L = `Having considered fully the Pay as you Grow (PAYG) options and my business’ financial position, 
  I have concluded that my business is in financial difficulty and I would like to discuss with you my circumstances`;
export const ATTESTATION_1_YES_ANSWER = "Yes, I would like to speak to someone";
export const ATTESTATION_1_NO_ANSWER =
  "No, I am comfortable with proceeding with the PAYG option I’ve chosen";

export const ATTESTATION_SCREEN_QUESTION_2 =
  "I have seen the options available to me and I don’t understand them and I would like to talk to someone";
export const ATTESTATION_2_YES_ANSWER =
  "Yes, I would like to speak to someone to better understand how the PAYG options will help me";
export const ATTESTATION_2_NO_ANSWER =
  "No, I understand how the PAYG options can help me and would like to proceed and I do NOT need to speak to someone";

export const ATTESTATION_SCREEN_QUESTION_3 = `If having seen the PAYG options you still believe that you may experience difficulties making repayments, or you have missed a payment 
  on your Bounce Back loan or any other borrowing you may have, or you are concerned about the impact Coronavirus has had on your business and finances, we would encourage 
  you to speak to us to understand what alternative options may be available`;
export const ATTESTATION_3_YES_ANSWER = "Yes, I would like to speak to someone";
export const ATTESTATION_3_NO_ANSWER =
  "No, I am comfortable that the PAYG options available to me will meet my needs at this present time and I do NOT need to speak to someone";
